// /* eslint-disable */
import React from "react";
import { translate } from "react-i18next";
import i18next from "Language/i18next";
import PropTypes from "prop-types";
// import { /* Link, */ Redirect } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import FacebookLogin from "react-facebook-login";
import GoogleLogin from "react-google-login";
// creates a beautiful scrollbar
import socialLogin from "utils/socialLogin";
import login from "utils/login";
import changePassword from "utils/changePassword";
import Email from "@material-ui/icons/Email";
import Icon from "@material-ui/core/Icon";
// import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Footer from "components/Footer/Footer.jsx";
// import CardFooter from "components/Card/CardFooter.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";
import config from "config/config.js";
import Header from "components/Header/Header.jsx";
import getFreshToken from "utils/xsrfToken.js";

const responseFacebook = (response, self) => {
  const [firstName, lastName] = response.name
    ? response.name.split(/\s/)
    : ["", ""];
  const objectToSend = {
    socialId: response.id,
    socialToken: response.accessToken, // token
    socialName: "facebook", // google/apple
    signupLanguage: "it", // linguaggio app
    email: response.email,
    firstName,
    middleName: "",
    lastName,
    gender: "other",
    location: null,
    username: response.name, // username o null
    avatar:
      response.picture && response.picture.url ? response.picture.url : null
  };
  return socialLogin(objectToSend).then(res => {
    if (res && res.success) {
      if (self.state.url) {
        self.redirectTo(self.state.url);
      } else {
        self.redirectTo("https://www.foodiestrip.com");
      }
    }
  });
};

const responseGoogle = (response, self) => {
  const data = response.profileObj;
  const objectToSend = {
    socialId: data.googleId,
    socialToken: response.accessToken, // token
    socialName: "google", // google/apple
    signupLanguage: "it", // linguaggio app
    email: data.email,
    firstName: data.givenName,
    middleName: "",
    lastName: data.familyName,
    gender: "other",
    location: null,
    username: data.name, // username o null
    avatar: data.imageUrl
  };
  return socialLogin(objectToSend).then(res => {
    if (res && res.success) {
      if (self.state.url) {
        self.redirectTo(self.state.url);
      } else {
        self.redirectTo("https://www.foodiestrip.com");
      }
    }
  });
};

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      values: {},
      redirect: null,
      errors: false,
      errorText: "",
      showPopup: false,
      showChangePassword: false,
      isReady: false
    };
    this.resizeFunction = this.resizeFunction.bind(this);
    this.getInput = this.getInput.bind(this);
    this.getInputChangePassword = this.getInputChangePassword.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  componentDidMount() {
    const xsrfToken = getFreshToken();
    const query = window.location.href.split("?");
    let uri = config.baseUrl;
    if (query && query[1]) {
      uri = query[1];
      this.setState({ url: query[1] });
    }
    if (xsrfToken) {
      console.log(xsrfToken);

      this.redirectTo(uri);
    } else {
      this.setState({ isReady: true });
    }
    console.log(query);
    if (navigator.platform.indexOf("Win") > -1) {
      // const ps = new PerfectScrollbar(this.refs.mainPanel);
    }
    const urlWithInitial = window.location.href;
    let url = "";
    if (urlWithInitial.split("//").length > 0) {
      url = urlWithInitial.split("//")[1];
    } else {
      url = urlWithInitial;
    }
    const language = url.split("/")[1];
    if (language === "it" || language === "en") {
      i18next.changeLanguage(language);
      // funzione per cambiare lingua!!!
      this.props.updateLanguage(language);
    } else if (!this.props.language) {
      this.props.updateLanguage("it");
    }
    window.addEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFunction);
  }
  redirectTo(href) {
    window.location = href;
  }
  hideAlert() {
    this.setState({ showPopup: false });
  }

  performLogin(user, pass) {
    const t = this.props.t;
    // console.log("user e pass", user, pass);
    return login(user, pass)
      .then(res => {
        // TODO: rifare if
        if (res && res.success) {
          if (this.state.url) {
            this.redirectTo(this.state.url);
          } else {
            this.redirectTo("https://www.foodiestrip.com");
          }
          // this.setState({ showChangePassword: true });
        } else {
          this.setState({
            showPopup: true,
            popupText: t("login.error_login_text"),
            popupTitle: t("login.error_login")
          });
          return null;
        }
        return null;
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log("err", err);
        this.setState({
          showPopup: true,
          popupText: t("login.error_login_text"),
          popupTitle: t("login.error_login")
        });
        return null;
      });
  }

  requestChangePassword(newPass, newPassRepeat) {
    const t = this.props.t;
    if (newPass !== newPassRepeat) {
      this.setState({
        errors: true,
        errorText: t("login.passwords_not_matching")
      });
      return null;
    }
    const url = this.state.url || "https://www.foodiestrip.com";
    return changePassword(newPass)
      .then(res => {
        if (res && res.success) {
          this.setState(
            {
              showChangePassword: false,
              showPopup: true,
              popupTitle: t("login.changed_password_succesfully_title"),
              popupText: t("login.changed_password_succesfully")
            },
            () => {
              setTimeout(this.redirectTo(url), 7000);
            }
          );
          return null;
        }
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log("err", err);
        this.setState(
          {
            showChangePassword: false,
            showPopup: true,
            popupTitle: t("login.changed_password_error_title"),
            popupText: t("login.changed_password_error")
          },
          () => {
            setTimeout(this.redirectTo(url), 7000);
          }
        );
        return null;
      });
  }

  getInputChangePassword(type) {
    return (
      <CustomInput
        labelText={this.props.t("login.label_" + type)}
        id={type}
        error={this.state.errors}
        inputProps={{
          value: this.state.values[type] || "",
          onChange: e => {
            const values = this.state.values;
            values[type] = e.target.value;
            if (this.state.errors) {
              this.setState({ values, errors: false, errorText: "" });
            } else {
              this.setState({ values });
            }
          },
          onKeyDown: e => {
            if (
              e.key === "Enter" &&
              this.state.values.newPassword &&
              this.state.values.newPasswordRepeat
            ) {
              // console.log("sono qui");
              this.requestChangePassword(
                this.state.values.newPassword,
                this.state.values.newPasswordRepeat
              );
            }
          },
          type: "password"
        }}
        formControlProps={{
          fullWidth: true
        }}
      />
    );
  }

  getInput(type) {
    return (
      <div style={{ position: "relative" }}>
        <CustomInput
          labelText={"" + type}
          id={type}
          inputProps={{
            value: this.state.values[type] || "",
            onChange: e => {
              const values = this.state.values;
              values[type] = e.target.value;
              this.setState({ values });
            },
            onKeyDown: e => {
              if (
                e.key === "Enter" &&
                this.state.values.email &&
                this.state.values.password
              ) {
                // console.log("sono qui");
                this.performLogin(
                  this.state.values.email,
                  this.state.values.password
                );
              }
            },
            type: type === "password" ? "password" : "text"
          }}
          formControlProps={{
            fullWidth: true
          }}
        />
      </div>
    );
  }
  render() {
    const { classes, t } = this.props;
    // console.log(this.state.isReady);
    if (!this.state.isReady) {
      return null;
    }
    return (
      <div
      // style={{
      //   backgroundImage: `url("${
      //     config.imageRoot
      //   }backoffice/sfondo-accedi.jpg")`,
      //   height: "unset",
      //   backgroundSize: "cover",
      //   backgroundPosition: "center"
      // }}
      // className={"page-background-image " + classes.wrapper}
      >
        <Header t={this.props.t} language={this.props.language} />
        <div
          // style={{ width: "100%" }}
          // className={classes.mainPanel}
          ref="mainPanel"
          style={{
            backgroundImage: `url("${
              config.imageRoot
            }backoffice/sfondo-accedi.jpg")`,
            height: "unset",
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
          className={
            "page-background-image " + classes.wrapper + classes.mainPanel
          }
        >
          {this.state.showPopup ? (
            <SweetAlert
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title={this.state.popupTitle}
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnCssClass={
                this.props.classes.button + " " + this.props.classes.success
              }
            >
              {this.state.popupText}
            </SweetAlert>
          ) : null}
          {this.state.showChangePassword ? (
            <SweetAlert
              warning
              // style={{ display: "block" }}
              title={t("login.change_password")}
              onConfirm={() =>
                this.requestChangePassword(
                  this.state.values.newPassword,
                  this.state.values.newPasswordRepeat
                )
              }
              onCancel={() => {}}
              confirmBtnCssClass={
                this.props.classes.button + " " + this.props.classes.success
              }
            >
              {t("login.first_time_change_password")}
              {this.getInputChangePassword("newPassword")}
              {this.getInputChangePassword("newPasswordRepeat")}
              {this.state.errorText ? (
                <div className="change-password-error">
                  * {this.state.errorText} *
                </div>
              ) : null}
            </SweetAlert>
          ) : null}
          <div className={classes.content} style={{ marginTop: "60px" }}>
            <div className={classes.container}>
              <GridContainer
                justify="center"
                alignItems="center"
                style={{ minHeight: "100vh", padding: "20px 0" }}
              >
                <GridItem xs={12} sm={2} md={3} />
                <GridItem xs={12} sm={8} md={6}>
                  <Card>
                    <CardHeader
                      style={{
                        margin: "-20px 15px 0",
                        borderRadius: "3px",
                        textAlign: "center"
                      }}
                      color="foodiestripRed"
                    >
                      <h4 className={classes.cardTitleWhite}>
                        {t("login.login")}
                      </h4>
                    </CardHeader>
                    <CardBody>
                      <GridContainer>
                        <GridItem xs={12} md={12} lg={6}>
                          <GridContainer style={{ marginTop: "30px" }}>
                            <GridItem xs={2} style={{ marginTop: "35px" }}>
                              <Email className={classes.inputAdornmentIcon} />
                            </GridItem>
                            <GridItem xs={10}>
                              {this.getInput("email")}
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={2} style={{ marginTop: "35px" }}>
                              <Icon className={classes.inputAdornmentIcon}>
                                lock_outline
                              </Icon>
                            </GridItem>
                            <GridItem xs={10}>
                              {this.getInput("password")}
                            </GridItem>
                          </GridContainer>
                          <GridContainer style={{ marginTop: "20px" }}>
                            <GridItem xs={2} />
                            <GridItem xs={10}>
                              <div className="backoffice-toc">
                                {t("login.toc1")}
                                <a
                                  target="_blank"
                                  href={`${
                                    config.blobBaseUrl
                                  }/note-legali/termini-e-condizioni/`}
                                >
                                  {t("login.toc2")}
                                </a>
                                {t("login.toc3")}
                                <a
                                  target="_blank"
                                  href={`${
                                    config.blobBaseUrl
                                  }/note-legali/policy-privacy/`}
                                >
                                  {t("login.toc4")}
                                </a>
                                {t("login.toc5")}
                                <a
                                  target="_blank"
                                  href={`${
                                    config.blobBaseUrl
                                  }/note-legali/cookie-policy/`}
                                >
                                  {t("login.toc6")}
                                </a>
                                {t("login.toc7")}
                              </div>
                            </GridItem>
                          </GridContainer>
                          <GridContainer
                            style={{ marginTop: "30px", marginBottom: "10px" }}
                            justify="center"
                          >
                            <Button
                              color="buttonFoodiestripRed"
                              round
                              onClick={() => {
                                if (
                                  this.state.values &&
                                  this.state.values.email &&
                                  this.state.values.password
                                ) {
                                  this.performLogin(
                                    this.state.values.email,
                                    this.state.values.password
                                  );
                                }
                              }}
                            >
                              {t("login.log").toUpperCase()}
                            </Button>
                          </GridContainer>
                          <div className="login-or">
                            <span>{t("or")}</span>
                          </div>
                          <GridContainer
                            style={{ marginTop: "10px" }}
                            className="social-login-buttons-container"
                            justify="center"
                          >
                            <FacebookLogin
                              appId="531130213901862"
                              autoLoad={false}
                              fields="name,email,picture"
                              callback={response =>
                                responseFacebook(response, this)
                              }
                              onClick={() => {}}
                              icon={"fa-facebook"}
                              cssClass="custom-facebook-login-button"
                              textButton={t("login.facebook_login")}
                            />
                            <GoogleLogin
                              clientId="81804603459-2dt8tvn6e0o691fm8p1k8aij2u2cnp6f.apps.googleusercontent.com"
                              buttonText={t("login.google_login")}
                              className="custom-google-login-button"
                              onSuccess={response =>
                                responseGoogle(response, this)
                              }
                              onFailure={() => {}}
                              cookiePolicy={"single_host_origin"}
                            />
                          </GridContainer>
                          {/* <GridContainer
                            style={{ marginTop: "10px" }}
                            justify="center"
                          >
                          </GridContainer> */}
                        </GridItem>
                        <GridItem xs={12} md={12} lg={6}>
                          <div className="backoffice-login-notes">
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              // href="https://www.foodiestrip.com/business/sign-up/"
                              href={`${config.baseUrl}/${
                                this.props.language
                                  ? this.props.language + "/"
                                  : ""
                              }business/sign-up/`}
                            >
                              {t("login.no_account_yet")}
                            </a>
                            <br />
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              className="backoffice-login-recover-password"
                              href={`${config.baseUrl}/${
                                this.props.language
                                  ? this.props.language + "/"
                                  : ""
                              }recover-credentials/`}
                              // href="https://www.foodiestrip.com/recover-credentials/"
                            >
                              {t("login.forgot_password")}
                            </a>
                          </div>
                        </GridItem>
                      </GridContainer>
                    </CardBody>
                  </Card>
                </GridItem>
                <GridItem xs={12} sm={2} md={3} />
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer t={this.props.t} language={this.props.language} />
      </div>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  updateTokens: PropTypes.func.isRequired,
  updateLanguage: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  firstRestaurant: PropTypes.string
};

const BaseLogin = translate()(Login);
export default withStyles(appStyle)(BaseLogin);



// WEBPACK FOOTER //
// ./src/layouts/Login.jsx